import React from 'react';
import { PageHeaderProps } from '@/components/page-header/types';
import clsx from 'clsx';
import { renameDomProps } from '@/utils/sanitizeDomProps';

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  theme = 'light',
  className,
  sectionId,
  // Discard: no image to preload, and it must not leak onto the DOM div.
  prerender: _prerender,
  ...rest
}) => {
  const renamedProps = renameDomProps(rest);
  return (
    <div
      id={sectionId}
      className={clsx(
        'smzh-page-header block',
        theme == 'light' ? 'bg-light-grey' : 'bg-brand-700',
        className,
      )}
      data-component-id="C024"
      {...renamedProps}
    >
      <div className="container mx-auto px-4 py-16 sm:px-0 sm:py-24">
        <h1
          className={clsx(
            'hyphens-auto break-words text-3xl font-bold sm:text-4xl md:text-5xl',
            theme == 'light' ? 'text-brand-700' : 'text-white',
          )}
        >
          {title}
        </h1>
      </div>
    </div>
  );
};
